/**
 * Renders a Fuel levy tariff as the "Fuel levy %" figure the admin screens show.
 * The API serialises decimals as strings, so both shapes are accepted.
 */
export const formatFuelLevyPercent = (tariff?: number | string | null): string => {
	if (tariff === undefined || tariff === null || tariff === '') {
		return '—';
	}
	const value = Number(tariff);
	if (isNaN(value)) {
		return '—';
	}
	return `${value.toFixed(2)}%`;
}
